import React from 'react';

import { AddPluginMenuMobileButton } from '../../components/buttons';
import { formattingItemsRenderers } from '../formatting/formatting-renderers';

export const mobileItemsRenderers = {
  ...formattingItemsRenderers,
  addPlugin: (toolbarItem: $TSFixMe) => {
    return <AddPluginMenuMobileButton toolbarItem={toolbarItem} />;
  },
};
